let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6TpaP")).then(() => parcelRequire('5NWMp'));